import React, { useContext, useRef, useEffect, type MutableRefObject } from 'react';

import { SideNav, SideNavItems } from '@carbon/react';
import { useNavItems } from 'src/util/NavItems';

import { NavContext } from 'src/util/context/NavContext';
import LeftNavItem from './LeftNavItem';

import LeftNavWrapper from './LeftNavWrapper';
import * as styles from './LeftNav.module.scss';

export type LeftNavProps = {
    theme?: 'dark' | 'white' | 'g10';
    homepage?: boolean;
    is404Page?: boolean;
};
export function LeftNav(props: LeftNavProps) {
    const { leftNavIsOpen, leftNavScrollTop, setLeftNavScrollTop, toggleNavState } = useContext(NavContext);

    const sideNavRef = useRef<HTMLElement>(null);
    const sideNavListRef = useRef() as MutableRefObject<HTMLElement | undefined>;

    useEffect(() => {
        if (!sideNavRef.current) return;
        sideNavListRef.current = sideNavRef.current.querySelector<HTMLElement>('.sidenav-list') ?? undefined;
    }, []);
    useEffect(() => {
        if (!sideNavListRef.current) return;

        sideNavListRef.current.addEventListener('scroll', e => {
            setLeftNavScrollTop((e.target as HTMLElement).scrollTop);
        });
    }, [setLeftNavScrollTop]);
    useEffect(() => {
        const el = sideNavListRef.current;
        if (!el) return;

        if (leftNavScrollTop >= 0 && !el.scrollTop) el.scrollTop = leftNavScrollTop;
    }, [leftNavScrollTop]);

    const leftNavClassName: string = props.theme === 'dark' ? styles.sideNavDark : styles.sideNavWhite;

    const navItems = useNavItems();
    const closeSwitcher = () => toggleNavState('switcherIsOpen', 'close');

    return (
        <LeftNavWrapper expanded={leftNavIsOpen} onClick={closeSwitcher} onKeyPress={closeSwitcher}>
            <SideNav
                ref={sideNavRef}
                aria-label="Side navigation"
                expanded
                isPersistent
                defaultExpanded
                className={leftNavClassName}
            >
                <SideNavItems
                    className="sidenav-list"
                    children={navItems.map((item, i) => {
                        return (
                            <LeftNavItem
                                key={i}
                                items={item.pages}
                                category={item.title}
                                hasDivider={item.hasDivider}
                            />
                        );
                    })}
                />
            </SideNav>
        </LeftNavWrapper>
    );
}
